import React from 'react'
import Icon from '../../../../Icon2/Icon'
import Tooltip from '../../../../Tooltip/Tooltip'

export type AssetPickerAccessMode = 'public' | 'private'

interface AssetPickerAccessBadgeProps {
  mode: AssetPickerAccessMode
  spaceName?: string
  position?: 'top' | 'right' | 'bottom' | 'left'
  variant?: 'inline' | 'badge'
}

const AssetPickerAccessBadge: React.FC<AssetPickerAccessBadgeProps> = ({
  mode,
  spaceName,
  position = 'top',
  variant = 'inline',
}) => {
  const isPrivate = mode === 'private'
  const title = isPrivate ? 'Asset is in restricted mode' : 'Asset is in public mode'
  const description = isPrivate
    ? `This asset has been restricted by the${spaceName ? ` '${spaceName}'` : ''} space admin.`
    : 'File can be accessed without any access token'
  const iconSize = variant === 'badge' ? 'small' : 'medium'

  return (
    <Tooltip
      content={
        <div className="cs-asset-picker-access-badge__tooltip">
          <div className="cs-asset-picker-access-badge__tooltip-title">{title}</div>
          <div className="cs-asset-picker-access-badge__tooltip-desc">{description}</div>
        </div>
      }
      position={position}
      showArrow
      maxWidth={260}
      interactive={false}
      appendTo={() => document.body}
    >
      <span
        className={`cs-asset-picker-access-badge cs-asset-picker-access-badge--${variant}`}
        role="img"
        aria-label={title}
        data-test-id={`cs-asset-picker-access-badge-${mode}`}
      >
        <Icon icon={isPrivate ? 'Lock' : 'Users'} version="v2" size={iconSize} />
      </span>
    </Tooltip>
  )
}

export default AssetPickerAccessBadge
